/** Grymwyrd Polish copy for the home hero. */
export const homePl = {
  'home.heroEyebrow': 'Żywy świat horroru-fantasy',
  'home.heroTitle': 'Wejdź w Twilight',
  'home.heroBody':
    'Grymwyrd to oszołomiony świat wiktoriańskiego gotyckiego horroru, gdzie we mgle zatopione miasto Greywick skrywa zrujnowane wieże, podziemia dworskie i rytuały lepiej pozostawić niewypowiedziane. Stwórz bohatera, przesuwaj zasłony Kataklizmu i wyryj swoje imię w świat, który pamiętuje.',
  'home.heroPlayCta': 'Graj Teraz',
  'home.heroBrowseCta': 'Przeglądaj Encyklopedię',
  'home.heroQuickstartPrompt': 'Nie gotów do gry? Pobierz darmowy Quickstart',
}
